import { FC } from "react";
import { Divider } from "@chakra-ui/react";
import { useIsMobile } from "~/hooks/useIsMobile";

interface Props {
  my?: number;
}

export const MobileDivider: FC<Props> = ({ my }) => {
  const isMobile = useIsMobile();

  return isMobile ? <Divider borderColor="th.gray1" my={my} /> : null;
};
